import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';
import { ResumeBuilderLayout } from '@/features/resume-builder/layout/ResumeBuilderLayout';
import { resumeSearchSchema } from '@/features/resume-builder/shared/resume-search.schema';

/**
 * EU-761 — layout do fluxo do currículo (`/modulos/$moduleId/curriculo/**`).
 * O `_` em `$moduleId_` evita aninhar sob a rota genérica do módulo
 * (`/modulos/$moduleId`), que renderiza a etapa; aqui é uma superfície própria.
 */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo')({
  validateSearch: resumeSearchSchema,
  component: () => (
    <HomeGate>
      <ResumeBuilderLayout />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
